module.exports = __webpack_public_path__ + "media/components/star-rating/static/white/8-2999ce697b8f980ed3237e8c516a8cc3.svg";